const features = [
  {
    icon: "ri-scissors-2-line",
    title: "Modelagem Premium",
    desc: "Silhuetas alongadas, alfaiataria contemporânea e tecidos que equilibram fluidez e estrutura.",
  },
  {
    icon: "ri-star-line",
    title: "Costura de Qualidade",
    desc: "Acabamento impecável com matérias-primas selecionadas que enaltecem a beleza feminina.",
  },
  {
    icon: "ri-leaf-line",
    title: "Tecidos Nobres",
    desc: "Seleção criteriosa de tecidos premium para garantir conforto e elegância em cada peça.",
  },
  {
    icon: "ri-truck-line",
    title: "Entrega Rápida",
    desc: "Enviamos para todo o Brasil com agilidade e segurança para sua loja.",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px bg-black/10" />
          <h2 className="text-[13px] tracking-[0.3em] font-semibold text-black uppercase">
            Por que nos escolher
          </h2>
          <div className="flex-1 h-px bg-black/10" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f) => (
            <div key={f.title} className="flex flex-col items-center text-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center border border-black/15">
                <i className={`${f.icon} text-xl text-black`} />
              </div>
              <div>
                <p className="text-[12px] tracking-[0.18em] font-semibold text-black mb-2 uppercase">
                  {f.title}
                </p>
                <p className="text-[12px] text-black/55 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 relative overflow-hidden" style={{ minHeight: "280px" }}>
          <img
            src="https://readdy.ai/api/search-image?query=Brazilian%20fashion%20boutique%20models%20wearing%20elegant%20collection%20outfits%2C%20warm%20brown%20terracotta%20background%2C%20editorial%20fashion%20photography%2C%20multiple%20models%2C%20sophisticated%20style%2C%20full%20body%20shots&width=1440&height=400&seq=cta-banner&orientation=landscape"
            alt="Aproveite nossas ofertas"
            className="w-full h-full object-cover object-top absolute inset-0"
            style={{ minHeight: "280px" }}
          />
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative z-10 flex flex-col items-center justify-center text-center text-white py-16 px-6">
            <p className="text-[10px] tracking-[0.3em] mb-3 opacity-70 uppercase">
              Ray Melo Boutique
            </p>
            <h3
              className="text-3xl md:text-4xl font-light tracking-[0.1em] mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              APROVEITE NOSSAS OFERTAS
            </h3>
            <a
              href="https://wa.me/5511923169450"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-white/70 px-8 py-3 text-[11px] tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line" />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
